import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  /*
  obtener() {
    var url = ConfigAPI.baseURL + "widget" + Session.getToken();
    return instance.get(url);
  },
  mostrar(id) {
    var url = ConfigAPI.baseURL + "widget/" + id + Session.getToken();
    return instance.get(url);
  },
  */
  mostrarByReferencia(data) {
    var param = data

    var url = ConfigAPI.baseURL + "widget/reference" + Session.getToken();
    return instance.post(url,param);
  },
  mostrarByReferenciaCustom(data) {
    var param = data

    var url = ConfigAPI.baseURL + "php/widget/reference" + Session.getToken();
    return instance.post(url,param);
  },  
  obtenerWidgetVisibility(module_id, profile_id) {
    var url = ConfigAPI.baseURL + "widget/visibility" + Session.getToken() + "&module_id=" + module_id + "&profile_id=" + profile_id;
    return instance.get(url);
  },
  guardarWidgetVisibility(data) {
    var params = data
    var url = ConfigAPI.baseURL + "widget/visibility" + Session.getToken();
    return instance.post(url,params);
  },
  guardarWidgetVisibilityBulk(data) {
    var params = data
    var url = ConfigAPI.baseURL + "widget/visibility/bulk" + Session.getToken();
    return instance.post(url,params);
  },
  guardarWidgetVisibilityOrder(data) {
    var params = data
    var url = ConfigAPI.baseURL + "widget/visibility/order" + Session.getToken();
    return instance.post(url,params);
  },
  resetWidgetVisibility(data) {
    var params = data
    var url = ConfigAPI.baseURL + "widget/visibility/reset" + Session.getToken();
    return instance.post(url,params);
  },
  obtenerWidgetConfig(module_id, profile_id) {
    var url = ConfigAPI.baseURL + "widget/visibility/config" + Session.getToken() + "&module_id=" + module_id + "&profile_id=" + profile_id;
    return instance.get(url);
  },
  guardarWidgetConfig(data) {
    var params = data
    var url = ConfigAPI.baseURL + "widget/visibility/config" + Session.getToken();
    return instance.post(url,params);
  },
  obtenerEmpleado() {
    var url = ConfigAPI.baseURL + "employee/employee" + Session.getToken();
    return instance.get(url);
  },    
}

export default servicesAPI;
